<template>
  <div class="weather-routing-result-panel block lg:flex lg:items-center">
    <div class="recommended-route-reference-rate w-full lg:w-64">
      <span class="aisea-text-14-600-dark-gray">推奨航路参照率</span>
      <span class="reference-rate-value"
        >{{ routeAgreementRate
        }}<span class="reference-rate-unit">%</span></span
      >
    </div>
    <div class="vertical-divider hidden lg:block" />
    <vs-divider class="block lg:hidden m-0"></vs-divider>
    <div class="table-content" v-if="weatherRoutingResultsData">
      <table id="result-table">
        <thead>
          <tr>
            <th></th>
            <th
              class="headers"
              v-for="(header, index) in headers"
              v-bind:key="index"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="result in weatherRoutingResultsData"
            v-bind:key="result.id"
          >
            <th>{{ result.itemName }}</th>
            <td>
              {{ result.accumulatedDistance }}<span class="unit"> nm </span>
            </td>
            <td class="total-underway-time">
              <span>
                {{ result.accumulatedTotalUnderwayTime.hour }}
              </span>
              <span class="unit"> h </span>
              <span>
                {{ result.accumulatedTotalUnderwayTime.min }}
              </span>
              <span class="unit"> m </span>
            </td>
            <td>
              {{ result.averageSpeedThroughWater
              }}<span class="unit"> kt </span>
            </td>
            <td :class="textColor(result.mainEngineFuelConsumption)">
              {{ result.mainEngineFuelConsumption
              }}<span class="unit"> L </span>
            </td>
            <td :class="textColor(result.mainEngineFuelConsumptionPerNm)">
              {{ result.mainEngineFuelConsumptionPerNm
              }}<span class="unit"> L/nm </span>
            </td>
            <td :class="textColor(result.mainEngineFuelConsumptionPerHour)">
              {{ result.mainEngineFuelConsumptionPerHour
              }}<span class="unit"> L/h </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("fuelConsumption");
export default {
  name: "WeatherRoutingResultPanel",
  components: {},
  data() {
    return {
      headers: [
        "航海距離",
        "航海時間",
        "平均対水速力",
        "主機燃料消費量",
        "主機燃料消費量(nm)",
        "主機燃料消費量(h)",
      ],
    };
  },
  computed: {
    ...mapState({
      routeAgreementRate: state => state.routeAgreementRate,
      weatherRoutingResultsData: state => state.weatherRoutingResultsData,
    }),
  },
  methods: {
    textColor(val) {
      if (val.includes("-") && val.length > 2) {
        return "minus-sign";
      }
      if (val.includes("+")) {
        return "plus-sign";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/aisea/typography";
@import "src/assets/scss/aisea/fuel-consumption";

.weather-routing-result-panel {
  @extend .panel-card-outline;
  border-radius: 4px;
  margin-top: 8px;

  .table-content {
    padding: 14px 20px;
    overflow-x: scroll;
  }

  #result-table {
    white-space: nowrap;
    overflow-x: scroll;
    border-collapse: collapse;

    thead {
      font-weight: 400;
      color: $aisea-dark-gray;
    }

    tbody {
      font-size: 1.1rem;
      border-collapse: collapse;

      td.title {
        font-weight: 600;
        display: flex;
        align-items: center;
        text-align: center;
      }

      tr:nth-child(1) {
        th,
        td {
          border-bottom: 1px solid $panel-card-border-color;
        }
      }

      td {
        text-align: right;
        padding: 0.35em;
      }
    }

    .plus-sign {
      color: $aisea-red;
    }

    .minus-sign {
      color: $aisea-blue;
    }

    .unit {
      font-size: 1rem;
    }
  }

  .result-table td {
    text-align: right;
  }

  .total-underway-time {
    text-align: center;
  }

  .recommended-route-reference-rate {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    .reference-rate-value {
      font-size: 32px;
      font-weight: 600;
      color: $aisea-blue;
      margin-left: 12px;
    }

    .reference-rate-unit {
      font-size: 14px;
      font-weight: 600;
      color: $aisea-blue;
      margin-left: 4px;
    }
  }

  .vertical-divider {
    width: 1px;
    height: 150px;
    background-color: $panel-card-border-color;
  }
}
</style>
